import { PersonDto, personFromDto } from "@domain/user/dtos";
import { Feedback } from "./feedback";

export interface FeedbackDto extends Omit<Feedback, "lastUpdateDate" | "createdAt" | "user"> {
	user: PersonDto;
	lastUpdateDate: string;
	createdAt: string;
}

export function feedbackFromDto(dto: FeedbackDto): Feedback {
	return {
		...dto,
		user: personFromDto(dto.user),
		lastUpdateDate: new Date(dto.lastUpdateDate),
		createdAt: new Date(dto.createdAt),
	};
}
